import { render, staticRenderFns } from "./FbSendToMessenger.vue?vue&type=template&id=41965d0a&"
import script from "./FbSendToMessenger.vue?vue&type=script&lang=js&"
export * from "./FbSendToMessenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports